import { currencyOptions } from "@/common/const";
import { fieldServiceTypeOptions } from "@/common/const/filter-options";
import fieldServiceHoursOptions from "@/common/const/filter-options/fieldServiceHours.options";
import { FormFieldsStrategyType } from "@/common/types";

const fieldsFormStrategy: FormFieldsStrategyType[] = [
  {
    inputType: "text",
    label: "Vendor Product Name",
    name: "vendorProductName",
    required: true,
  },
  {
    inputType: "text",
    label: "Country",
    name: "country",
    required: true,
  },
  {
    inputType: "select",
    label: "Field Service Type",
    name: "fieldServiceType",
    required: true,
    options: fieldServiceTypeOptions,
  },
  {
    inputType: "select",
    label: "Hours Type",
    name: "hoursType",
    required: true,
    options: fieldServiceHoursOptions,
  },
  {
    label: "Currency",
    name: "currency",
    readonly: false,
    required: false,
    inputType: "select",
    options: currencyOptions,
  },
  {
    inputType: "text",
    label: "No. of Hours",
    name: "noOfHours",
    required: true,
    pattern: /^[2-8]$/,
    errorMessage: "The value must be an integer between 2 and 8.",
  },
  {
    inputType: "text",
    label: "OTE",
    name: "OTE",
    required: true,
  },
  {
    inputType: "text",
    label: "Extra Hours Rate",
    name: "extraHoursRate",
    required: true,
  },
  {
    inputType: "text",
    label: "Lead Time (in Days)",
    name: "leadTeam",
    required: true,
  },
  {
    label: "Price code",
    name: "priceCode",
    required: false,
    inputType: "text",
  },
];
export default fieldsFormStrategy;
